<nav role="navigation" #navHeader>
  <button
    [disabled]="startPosition"
    *ngIf="hasScroll"
    class="clean-button right-boxshadow"
    (click)="updateScrollToLeft()"
    aria-label="Mover para esquerda">
    <mat-icon class="scroll-button-icon">chevron_left</mat-icon>
  </button>
  <div class="seds-overflow-hidden seds-px-1" #menuItens>
    <ul role="menu">
      <li
        role="menuitem"
        [ngClass]="{ 'menu-item-selected': menu?.isSelected }"
        *ngFor="let menu of headerMenuList; index as i">
        <div *ngIf="menu.children?.length; then withChild; else withoutChild"></div>

        <ng-template #withChild>
          <div
            sedsHoverLi
            [(isOpen)]="menu.isOpen"
            [settedIndex]="i"
            class="menu-item-box"
            cdkOverlayOrigin
            #trigger="cdkOverlayOrigin">
            <button
              (click)="navigate(menu)"
              (keydown.enter)="acessibiltyOverlay(i, true)"
              class="menu-item-font-style clean-button seds-d-flex"
              [attr.aria-label]="menu.name">
              <mat-icon class="icon-menu-item seds-me-2" *ngIf="menu.iconName">{{ menu.iconName }}</mat-icon>
              {{ menu.name }}
              <mat-icon class="icon-menu-item seds-ms-2" *ngIf="menu.children?.length">expand_more</mat-icon>
            </button>
          </div>

          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayOpen]="menu.isOpen">
            <ul
              cdkTrapFocus
              [cdkTrapFocusAutoCapture]="true"
              sedsHoverLi
              [(isOpen)]="menu.isOpen"
              [settedIndex]="i"
              sedsViewFix
              class="submenu-list">
              <li
                tabindex="0"
                (keydown.esc)="acessibiltyOverlay(i, false)"
                *ngFor="let submenu of menu.children"
                class="submenu-item-box submenu-item seds-my-1">
                <mat-icon class="icon-menu-item submenu-icon">chevron_right</mat-icon>
                <a (click)="navigate(submenu)" class="menu-item-font-style submenu-link">{{ submenu.name }}</a>
              </li>
            </ul>
          </ng-template>
        </ng-template>

        <ng-template #withoutChild>
          <div class="menu-item-box">
            <button (click)="navigate(menu)" class="menu-item-font-style clean-button" [attr.aria-label]="menu.name">
              <mat-icon class="icon-menu-item me-2" *ngIf="menu.iconName">{{ menu.iconName }}</mat-icon>
              {{ menu.name }}
            </button>
          </div>
        </ng-template>
      </li>
    </ul>
  </div>
  <button
    [disabled]="endPosition"
    *ngIf="hasScroll"
    class="clean-button left-boxshadow"
    (click)="updateScrollToRight()"
    aria-label="Mover para direita">
    <mat-icon class="scroll-button-icon">chevron_right</mat-icon>
  </button>
</nav>
